module.exports = __webpack_public_path__ + "static/img/homes1.1715164.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/homes1.png
// module id = qP7I
// module chunks = 2